import React from 'react';
import { 
  IoBook, 
  IoVideocam, 
  IoChatbubbles, 
  IoCash, 
  IoCalendar, 
  IoSchool 
} from 'react-icons/io5';
import DemoBanner from '@/components/DemoBanner';
import './Resources.css';

const Resources: React.FC = () => {
  const resources = [
    {
      id: 1,
      icon: IoBook,
      title: 'Essay Writing Guide',
      description: 'Comprehensive guide to writing compelling college essays with examples and tips.',
      link: '#',
      linkText: 'Read More →',
      bgColor: 'bg-blue-100',
      iconColor: 'text-blue-600',
    },
    {
      id: 2,
      icon: IoVideocam,
      title: 'Video Tutorials',
      description: 'Step-by-step video guides for completing each section of your application.',
      link: '#',
      linkText: 'Watch Now →',
      bgColor: 'bg-green-100',
      iconColor: 'text-green-600',
    },
    {
      id: 3,
      icon: IoChatbubbles,
      title: 'Community Forum',
      description: 'Connect with other students and share advice on the application process.',
      link: '#',
      linkText: 'Join Discussion →',
      bgColor: 'bg-purple-100',
      iconColor: 'text-purple-600',
    },
    {
      id: 4,
      icon: IoCash,
      title: 'Financial Aid Calculator',
      description: 'Estimate your financial aid eligibility and scholarship opportunities.',
      link: '#',
      linkText: 'Calculate →',
      bgColor: 'bg-yellow-100',
      iconColor: 'text-yellow-600',
    },
    {
      id: 5,
      icon: IoCalendar,
      title: 'Deadline Tracker',
      description: 'Never miss a deadline with automated reminders and calendar sync.',
      link: '#',
      linkText: 'Set Reminders →',
      bgColor: 'bg-red-100',
      iconColor: 'text-red-600',
    },
    {
      id: 6,
      icon: IoSchool,
      title: 'School Research Tool',
      description: 'Compare schools, admission rates, and find your best fit colleges.',
      link: '#',
      linkText: 'Explore Schools →',
      bgColor: 'bg-indigo-100',
      iconColor: 'text-indigo-600',
    },
  ];

  return (
    <div className="resources-page dark:bg-gray-900">
      <div className="resources-container">
        <DemoBanner />
        <div className="resources-section dark:bg-gray-800 dark:border-gray-700">
          <div className="resources-header">
            <h2 className="resources-title dark:text-gray-100">Resources & Tools</h2>
            <a href="#" className="resources-view-all dark:text-blue-400 dark:hover:text-blue-300">
              View All Resources
            </a>
          </div>

          <div className="resources-grid">
            {resources.map((resource) => {
              const IconComponent = resource.icon;
              return (
                <div 
                  key={resource.id} 
                  className="resource-card dark:bg-gray-800 dark:border-gray-700 dark:hover:bg-gray-750"
                  onClick={() => resource.link !== '#' && window.open(resource.link, '_blank')}
                >
                  <div className={`resource-icon-container ${resource.bgColor} dark:bg-opacity-20`}>
                    <IconComponent className={`resource-icon ${resource.iconColor} dark:opacity-90`} />
                  </div>
                  <h3 className="resource-title dark:text-gray-100">{resource.title}</h3>
                  <p className="resource-description dark:text-gray-300">{resource.description}</p>
                  <a 
                    href={resource.link} 
                    className="resource-link dark:text-blue-400 dark:hover:text-blue-300"
                    onClick={(e) => {
                      if (resource.link === '#') {
                        e.preventDefault();
                      }
                    }}
                  >
                    {resource.linkText}
                  </a>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Resources;

